import { Injectable } from "@angular/core";
import { ApiHttpService } from "./api-http.service";
import { Observable } from "rxjs";
import { SavedRequest, TissueCollectionType } from "./request.service";

@Injectable()
export class PlanningService {
  constructor(private apiHttp: ApiHttpService) {}

  public getPlanningNotes = (requestId: number): Observable<PlanningInformation> => {
    return this.apiHttp.get<PlanningInformation>(`requests/${requestId}/planningnotes`).map(n => {
      if (n) {
        n.plannedPlantingDate = n.plannedPlantingDate ? new Date(n.plannedPlantingDate) : null;
      }
      return n;
    })
  };

  public savePlanningNotes = (planningNotes: PlanningInformation): Observable<SavedRequest> => {
    return this.apiHttp.put<SavedRequest>(`requests/${planningNotes.id}/planningnotes`, planningNotes);
  }
}

export interface PlanningInformation {
    id: number;
    tagsOnly: boolean;
    insectsAllowed?: boolean;
    specificAoiRequired: boolean;
    plannedAoiLocation: string;
    plantCareTemplateId?: number;
    plannedPlantingDate: Date;
    notes: string;
    requestTypeId: number; 
    treatmentDetails: PlanningTreatmentDetail[];
    samplingNeeds: SamplingNeeds[]; 
}

export interface PlanningTreatmentDetail {
  treatmentNumber: number;
  flatStorageFacilityTypeId: number;
  flatStorageFacilityLocationId: number;
  automationPotStorageFacilityTypeId: number;
  automationPotStorageLocationId: number;
  staticPotStorageFacilityTypeId: number;
  staticPotStorageLocationId: number;
  comments: PlanningTreatmentComment[];
  sprayEventData: sprayEventData[];
}

export interface sprayEventData {
  sprayEventNumber: number;
  sprayEventDaysAfterPlanting: number;
}

export interface PlanningTreatmentComment {
  instructionType: PlanningInformationType;
  instructionSubtype: PlanningInformationSubtype;
  comment: string;
}

export enum PlanningInformationType {
    Unknown,
    FlatInstruction,
    PottingInstruction,
    PlantHandlingInstruction
}

export enum PlanningInformationSubtype {
    Unknown,
    Substrate,
    Irrigation,
    Fertigation,
    Lighting,
    Temperature,
    Humidity,
    Pesticide
}

export class SamplingNeeds {
  order: number;
  laboratoryAssayId: number;
  laboratoryId: number;
  tissueTypeId: number;
  tissueCollectionType: TissueCollectionType;
  growthStageId: number;
  daysAfterPlanting: number;
  notes: string;
}



// WEBPACK FOOTER //
// F:/PHAZP5152IS01-2/_work/98/s/src/app/shared/services/planning.service.ts